import {useLocalStorage} from 'platform/components';

export type DistributionAxisMode = 'linear' | 'priceBands';

const STORAGE_KEY = 'priceReport.distributionAxisMode';

/**
 * Which X axis the price distribution uses — the even 50-slot scale or the portal's
 * price bands. The choice is the user's viewing preference; the platform hook keeps
 * it in localStorage (persisted across reports and sessions) and synchronised
 * across hook instances and browser tabs. Unknown stored values fall back to
 * 'linear' so a stale entry can never force an invalid mode.
 */
export function useDistributionAxisMode() {
  const [storedMode, setStoredMode] = useLocalStorage<DistributionAxisMode>(STORAGE_KEY, 'linear');
  const axisMode: DistributionAxisMode = storedMode === 'priceBands' ? 'priceBands' : 'linear';

  return [axisMode, setStoredMode] as const;
}
